import { POST_API_PATH, GET_API_PATH } from "../../../constants"
import apiSetting from "../apiSetting"

const getOrders = async (query) => {
    try {
        const queryParams = new URLSearchParams(query).toString();
        const response = await apiSetting({ method: 'GET', url: `${GET_API_PATH.GET_URL_ORDERS}?${queryParams}`, data: null })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const getUnSendOrder = async () => {
    try {
        const response = await apiSetting({ method: 'GET', url: GET_API_PATH.GET_URL_UNSHIPPED_ORDERS, data: null })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const getDeliverOrders = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: `${POST_API_PATH.POST_URL_DELIVER_ORDERS}?orderId=[${data.orderId}]`, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const createOrder = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_CREATE_ORDER, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const updateOrder = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_UPDATE_ORDER, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const uploadOrderImage = async (data, type) => {
    try {
        const response = await apiSetting({ method: 'POST', url: `${POST_API_PATH.POST_URL_UPLOAD_ORDER_IMAGE}?type=${type}`, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const updateOrderDeliver = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_UPDATE_ORDER_DELIVER, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

export { getOrders, getUnSendOrder, getDeliverOrders, createOrder, updateOrder, uploadOrderImage, updateOrderDeliver } 